import React from 'react';
import ContentBannerV4 from '@ajat/design-system/ContentBlocks/ContentBannerV4';
import { ComponentPage, DemoCard } from '../../shared';
import { CONTENT_BANNER_V4 } from './contentDemoData';

export const meta = {
  component: ContentBannerV4,
  title: 'Content Banner V4',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/ContentBannerV4',
  figmaNode: '69:19626',
  description:
    'A gray-025 band of white info cards (Crown Student homepage, Figma Crownstudent-MCP 69:19626 — desktop only, the cards stack on phones): each card a product photo shown `cover` in an 812:440 box with a promo chip over its top-right corner (DS Badge `brand` / `l` / `square` — «GRATIS», «INGÅR ALLTID»), a title (H3 style), P.Regular copy and a DS Hyperlink with an arrow. Three cards a row from 1024px on 48 / 24 gaps, card padding medium-l, --radius-card + --shadow-card-m2; the cards stretch to the row. A link without `linkHref` has no target yet: `href="#"`, the click never jumps the page. Every value is a DS token — no component tokens; the photo ratio and the column count are CSS hooks.',
  props: [
    ['items', 'array', '[]', '[{ title, text, image: { src, alt }, chip, linkLabel, linkHref, linkOnClick }] — one card each; no image → no photo box (and no chip), no label → no link; [] renders nothing'],
    ['titleAs', 'elementType', "'h2'", 'Heading element of the card titles (the style is always typo-h3)'],
    ['className', 'string', "''", 'Additional CSS class on the <section> (other attributes reach it too)'],
  ],
  usage: [
    {
      title: 'On the Crown Student landing',
      code: `import ContentBannerV4 from '@ajat/design-system/ContentBlocks/ContentBannerV4';

<ContentBannerV4
  items={[
    {
      chip: 'Gratis',
      title: 'Black Box',
      text: 'Kolla in Black Boxen: flera av Crownstudents allra bästa produkter samlade i en box till dig!',
      image: { src: blackBox, alt: 'Black Box med studentmössor' },
      linkLabel: 'Beställ nu',            // no linkHref yet → href="#", the click is a no-op
    },
    {
      chip: 'Ingår alltid',
      title: 'Trygghet och garantier',
      text: 'Din student är viktig för oss! …',
      image: { src: guarantees, alt: 'Uppslagen broschyr' },
      linkLabel: 'Läs mer',
      linkHref: '/garantier',
    },
  ]}
/>`,
    },
  ],
};

export default function ContentBannerV4Page() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard
        title="Three cards: photo with a chip, title, copy, arrow link"
        hint="Figma Crownstudent-MCP 69:19626 · stacked under 1024px · switch the top-bar brand to Crownstudent for the Figma look (pink chip text)"
        flush
      >
        <ContentBannerV4 items={CONTENT_BANNER_V4} />
      </DemoCard>
      <DemoCard title="Without chip and link" hint="No chip → nothing over the photo; no label → no link; two cards share the row" flush>
        <ContentBannerV4 items={CONTENT_BANNER_V4.slice(0, 2).map((item) => ({ ...item, chip: undefined, linkLabel: undefined }))} />
      </DemoCard>
    </ComponentPage>
  );
}
